import type { OvpClient } from '@bldsoft/cappie/api/ovp'
import type { API } from '@setplex/tria-api'
import { payload } from '../../result'

export function use(
  client: OvpClient,
  channelOwners: API['channelOwners'],
  _api: API
): void {
  // POST /api/web/feedback/live-lead-request
  channelOwners.setChannelOwnerDataFx.use(async (params) => {
    payload(
      await client.post.api.web.feedback.liveLeadRequest({ body: params })
    )
  })
}
